import useBaseFetch from "../../internal/fetch/useBaseFetch";
/**
 * @see https://sail.stripe.me/data/api/useTextFetch
 */ export default function useTextFetch(/** The URL of the resource to be fetched. */ url, /** An object containing custom settings to be applied to the request. */ options = {}) {
    return useBaseFetch(url, options, 'text');
}

//# sourceMappingURL=useTextFetch.js.map